package com.schoolconnect.app.datasource.network.request

import kotlinx.serialization.EncodeDefault
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class UserCreateRequest(
    @SerialName("full_name")
    val fullName: String,
    val mobile: String,
    val email: String? = null,
    @SerialName("role_id")
    val roleId: Int,
    @SerialName("school_id")
    val schoolId: String? = null,
    @EncodeDefault
    @SerialName("is_active")
    val isActive: Boolean = true
)

@Serializable
data class UserUpdateRequest(
    @SerialName("full_name")
    val fullName: String? = null,
    val mobile: String? = null,
    val email: String? = null,
    @SerialName("is_active")
    val isActive: Boolean? = null
)

@Serializable
data class UserToggleStatusRequest(
    @SerialName("is_active")
    val isActive: Boolean
)

@Serializable
data class UserSchoolRoleUpdateRequest(
    @SerialName("user_id")
    val userId: String? = null,
    @SerialName("role_id")
    val roleId: Int? = null,
    @SerialName("school_id")
    val schoolId: String? = null,
    @SerialName("is_active")
    val isActive: Boolean? = null,
    @SerialName("preferred_role")
    val preferredRole: Boolean? = null
)
